import { render } from "./Popup.vue?vue&type=template&id=57817acc&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=57817acc&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-57817acc"

export default script